import { useEffect, useState } from "react";

/**
 * Detecta capacidade de instalar PWA e expõe função de prompt.
 * - Safe para Safari antigo (usa guards em matchMedia).
 * - Detecta iOS por UA (útil para exibir instruções manuais).
 */
export function useInstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    let isStandalone = false;
    try {
      isStandalone =
        (typeof window !== "undefined" &&
          window.matchMedia &&
          window.matchMedia("(display-mode: standalone)").matches) ||
        (window.navigator && window.navigator.standalone === true);
    } catch { /* Safari muito antigo — assume não instalado */ }
    setInstalled(!!isStandalone);

    const handler = (e) => {
      try { e.preventDefault(); } catch {}
      setDeferred(e);
    };
    const installedHandler = () => {
      setInstalled(true);
      setDeferred(null);
    };
    try {
      window.addEventListener("beforeinstallprompt", handler);
      window.addEventListener("appinstalled", installedHandler);
    } catch {}
    return () => {
      try {
        window.removeEventListener("beforeinstallprompt", handler);
        window.removeEventListener("appinstalled", installedHandler);
      } catch {}
    };
  }, []);

  let isIos = false;
  try {
    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    isIos = /iPhone|iPad|iPod/.test(ua) && !window.MSStream;
  } catch {}

  const canPrompt = !!deferred;
  const canInstall = (canPrompt || isIos) && !installed;

  const prompt = async () => {
    if (!deferred) return { outcome: "unavailable" };
    try {
      deferred.prompt();
      const choice = await deferred.userChoice;
      setDeferred(null);
      return choice;
    } catch {
      setDeferred(null);
      return { outcome: "error" };
    }
  };

  return { canInstall, canPrompt, isIos, installed, prompt };
}
